export class HeadingLocaleKey {
  static textKeywordJobLocation = {
    id: `text-keyword-job-location`,
    defaultMessage: `Job Vacancy for {keyword} in {location} {currentMonth} {currentYear}`,
  };
  static textKeywordEducationLevel = {
    id: `text-keyword-education-level`,
    defaultMessage: `Job Vacancy for {keyword} for {educationLevel} graduates {currentMonth} {currentYear}`,
  };
  static textKeywordJobType = {
    id: `text-keyword-job-type`,
    defaultMessage: `Job Vacancy for {keyword} - {jobType} {currentMonth} {currentYear}`,
  };
  static textKeywordWorkArrangement = {
    id: `text-keyword-work-arrangement`,
    defaultMessage: `Job Vacancy for {keyword} - {workArrangements} {currentMonth} {currentYear}`,
  };
  static textTitleJobInCurrentTime = {
    id: `text-keyword-job-in-current-time`,
    defaultMessage: `{keyword} Jobs in {currentMonth}, {currentYear}`,
  };
}

export class MetaDataLocaleKey {
  static educationLevelFilter = {
    title: {
      id: `text-meta-keyword-education-level-title`,
      defaultMessage: `New {keyword} Job Vacancy for {education} Graduates in Indonesia on {currentMonth} {currentYear} | Glints TapLoker`,
    },
    description: {
      id: `text-meta-keyword-education-level-desc`,
      defaultMessage: `{keyword} job vacancy for {education} graduates in Indonesia on {currentMonth} {currentYear}, {keyword} jobs with competitive salary, direct chat with HR only on Glints TapLoker`,
    },
  };
  static locationFilter = {
    title: {
      id: `text-meta-keyword-job-location-title`,
      defaultMessage: `New {keyword} Job Vacancy in {location} on {currentMonth} {currentYear} | Glints TapLoker`,
    },
    description: {
      id: `text-meta-keyword-job-location-desc`,
      defaultMessage: `Job vacancy for {keyword} in {location} on {currentMonth} {currentYear} for all graduates and experience levels. {keyword} jobs in {location} with competitive salary, fast process by direct chat with HR, easy apply with just 1 tap on Glints TapLoker`,
    },
  };
  static jobTypeFilter = {
    title: {
      id: `text-meta-keyword-job-type-title`,
      defaultMessage: `New keyword jobType Job Vacancy in Indonesia on {currentMonth} {currentYear} | Glints TapLoker`,
    },
    description: {
      id: `text-meta-keyword-job-type-desc`,
      defaultMessage: `New keyword jobType job vacancy in Indonesia on {currentMonth} {currentYear} for all graduates and experience levels. keyword jobType jobs with competitive salary, direct chat with HR, easy apply with just 1 tap on Glints TapLoker`,
    },
  };
  static workArrangementOptionFilter = {
    title: {
      id: `text-meta-keyword-work-arrangement-title`,
      defaultMessage: `New keyword workArrangements Job Vacancy in Indonesia on {currentMonth} {currentYear} | Glints TapLoker`,
    },
    description: {
      id: `text-meta-keyword-work-arrangement-desc`,
      defaultMessage: `New keyword workArrangements job vacancy in Indonesia on {currentMonth} {currentYear} for all graduates and experience levels. keyword workArrangements job vacancies with competitive salary, direct chat with HR, easy apply with just 1 tap on Glints TapLoker`,
    },
  };
  static mainKeyword = {
    title: {
      id: `text-meta-keyword-title`,
      defaultMessage: `New {keyword} Job Vacancy in {location} on {currentMonth} {currentYear} | Glints TapLoker`,
    },
    description: {
      id: `text-meta-keyword-desc`,
      defaultMessage: `Job vacancy for {keyword} in {location} on {currentMonth} {currentYear} for all graduates and experience levels. {keyword} jobs in {location} with competitive salary, fast process by direct chat with HR, easy apply with just 1 tap on Glints TapLoker`,
    },
  };
}
